import { Flex, type FlexProps } from '@chakra-ui/react'

export default function PlatformHeaderBase({
  leftContent,
  rightContent,
  ...props
}: {
  leftContent?: JSX.Element
  rightContent?: JSX.Element
} & FlexProps) {
  return (
    <Flex
      width="100%"
      height="64px"
      justifyContent="space-between"
      alignItems="center"
      px="20px"
      {...props}
    >
      {leftContent}
      {rightContent}
    </Flex>
  )
}
